module.exports = __webpack_public_path__ + "static/img/13.626e6f0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/4/zh/13.png
// module id = OT17
// module chunks = 0